export function popupHandler() {
  const popups = document.querySelectorAll('.popup');
  if (!popups.length) return;

  // Open popup by trigger [data-popup]
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-popup]');
    if (!trigger) return;

    e.preventDefault();
    const popupId = trigger.getAttribute('data-popup');
    const popup = document.getElementById(popupId);
    if (!popup) return;

    popup.classList.add('is-active');
    document.body.classList.add('scroll-lock');
  });

  // Close popup
  popups.forEach(popup => {
    const closeBtn = popup.querySelector('.popup__close');
    const overlay = popup.querySelector('.popup__overlay');

    if (closeBtn) {
      closeBtn.addEventListener('click', () => closePopup(popup));
    }

    if (overlay) {
      overlay.addEventListener('click', () => closePopup(popup));
    }
  });

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const activePopup = document.querySelector('.popup.is-active');
      if (activePopup) closePopup(activePopup);
    }
  });

  function closePopup(popup) {
    popup.classList.remove('is-active');
    document.body.classList.remove('scroll-lock');
  }
}
